import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Select from "react-select";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
// import AddPalletesationTables from "../tables/AddPalletesationTable";
import { useFormik, FormikProvider, FieldArray } from "formik";

import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import { Apitoken, Authtoken } from "../Global";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import $ from "jquery";
const ExpenseEdit = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [value, setValue] = useState({});

  const [backendErrors, setBackendErrors] = useState([]);
  const [permission, setPermission] = useState({});

  const [typeLists, setTypeLists] = useState([]);
  const [supplierName, setSupplierName] = useState([]);
  const [currencySymbol, setCurrencySymbol] = useState('');
  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  const [itemsexp, setItemsexp] = useState([]);

  let season_id = localStorage.getItem("season_id");

  const tvarates = ([
    { value: '0', label: "0%" },
    { value: '7', label: "7%" },
    { value: '10', label: "10%" },
    { value: '12', label: "12%" },
    { value: '14', label: "14%" },
    { value: '15', label: "15%" },
    { value: '18', label: "18%" },
    { value: '20', label: "20%" },
    // { value: '111', label: "Other" },
  ]);

  const naturelist = ([
    { value: 'Export', label: "Export" },
    { value: 'Import', label: "Import" },
    { value: 'Autre', label: "Autre" },
  ]);
  const formik = useFormik({
    initialValues: {
      id: value.id,
      type: value.type,
      season_id: season_id,
      if: value.if,
      ice: value.ice,
      nature: value.nature,
      expense_type_extention: value.expense_type_extention,
      invoice_number: value.invoice_number,
      invoice_attachment: value.invoice_attachment,
      invoice_date: value.invoice_date,
      invoice_due_date: value.invoice_due_date,
      expense_type: value.expense_type,
      //designation: value.designation,
      amount_ht: value.amount_ht,
      //tva_rate: value.tva_rate,
      //other_tva_rate: value.other_tva_rate,
      supplier: value.supplier,
      currency: value.currency,
      total_amount_ttc: value.total_amount_ttc,
      // tva_amount:value.tva_amount,
      contents: itemsexp
    },
    enableReinitialize: true,
    //validationSchema: EditUserSchema,
    onSubmit: (values, { setSubmitting }) => {
      $("#form-submit").prop("disabled", true);
      $("#form-submit").text("Updating...");
      axios
        .post("/expenses/update", values, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        }).then((response) => {
          delete backendErrors['error'];
          setSubmitting(false);
          $("#form-submit").prop("disabled", false);
          $("#form-submit").text("Update Expense");
          if (response.data.code === 200) {
            toast.success(response.data.message);
            setTimeout(() => {
              window.location.href = "/expenses";
            }, 1000);
          } else if (response.data.code === 422) {
            setBackendErrors(response.data.error);
          }
          else if (response.data.code === 401) {
            setBackendErrors(response.data.error);
          }
          else {
            setBackendErrors(response.data.error);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  });
  const primaryCurrency = [
    {
      "label": "EUR",
      "value": 1,
      "symbol": "€",
      "key": "cabrane-0"
    },
    {
      "label": "USD",
      "value": 2,
      "symbol": "$",
      "key": "cabrane-1"
    },
    {
      "label": "GBP",
      "value": 3,
      "symbol": "£",
      "key": "cabrane-2"
    },
    {
      "label": "MAD ",
      "value": 4,
      "symbol": "dh",
      "key": "cabrane-3"
    }
  ];

  useEffect(() => {
    setPermission(FindModuleById(271));
    console.log(permission);

    axios
      .get(`/expenses/edit/${season_id + '-' + id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          setValue(response.data.data.expense);
          setItemsexp(response.data.data.expense.items);

          let exp = response.data.data.expense;

          if (exp.supplier != "") {
            axios.get(`/financessuppliers/expenses-type-listing/${exp.supplier}`, {
              headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
            })
              .then((response) => {
                if (response.data.code === 200) {
                  let customers = response.data.data.types;
                  let addresses = customers.map((customer, index) => ({
                    label: customer.title,
                    value: customer.title,
                    key: `address-${index}`,
                  }));
                  setTypeLists(addresses);
                }
              })
              .catch((error) => {
                console.log(error);
              });
          }

          const currencydetail = primaryCurrency.find(item => item.value === response.data.data.expense.currency) || null;
          setCurrencySymbol(currencydetail ? currencydetail.symbol : 'dh');
          $("#invoice_number_title").text('Invoice Number'); // corrected .text()

          if (response.data.data.expense.type == 2) {
            $("#invoice_number_title").text('Credit Note Number');
          }

          $("#other_tva_rate-block").hide();
          if (exp.tva_rate == '111') {
            $("#other_tva_rate-block").show();
          }

          console.log(exp);
          $("#nature-block").hide();
          $("#expense_type_extention-block").hide();

          if (exp.expense_type == 5) {
            $("#nature-block").show();

          } else if (exp.expense_type == 16 || exp.expense_type == 'Autres') {
            $("#expense_type_extention-block").show();

          } else {
            $("#nature-block").hide();

          }

        }
      })
      .catch((error) => {
        console.log(error);
      });

  }, [id]);



  useEffect(() => {


    axios
      .post(`/financessuppliers/listing`, {}, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          let types = response.data.data.suppliers;
          let typeslisting = types.map((ord, index) => ({
            if: ord.if,
            ice: ord.ice,
            label: ord.name,
            value: ord.id,
            key: `location-${index}`,
          }));
          setSupplierName(typeslisting);
        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const customHandleInput = (event) => {
    const Input_name = event.target.name;
    delete backendErrors[Input_name];
  };

  const customFuction = (event) => {
    console.log(event)
    setCurrencySymbol(event.symbol)

  }


  const changeExpenseType = (event) => {
    console.log("event");
    console.log(event);


    $("#nature-block").hide();
    $("#expense_type_extention-block").hide();

    if (event == 5) {
      $("#nature-block").show();

    } else if (event == 'Autres') {
      $("#expense_type_extention-block").show();

    } else {
      $("#nature-block").hide();

    }


  }





  useEffect(() => {
    const calculateTotalAmountTTC = () => {

      // amount HT (root level)
      const amountHT = parseFloat(formik.values.amount_ht) || 0;

      // sum all TVA amounts from contents[]
      const totalTVA = formik.values.contents.reduce((sum, item) => {
        const val = parseFloat(item.tva_amount);
        return sum + (isNaN(val) ? 0 : val);
      }, 0);

      // final total
      const total = amountHT + totalTVA;

      formik.setFieldValue("total_amount_ttc", total);

    };

    calculateTotalAmountTTC();
  }, [formik.values.amount_ht, formik.values.contents]);

  const handleSelectChange = (name, selectedOption) => {
    const value = selectedOption ? selectedOption.value : "";
    updateFormikValue(name, value);
    customHandleInput({ target: { name, value } });
  };

  const updateFormikValue = (name, value) => {
    formik.setFieldValue(name, value);
  };



  const changeType = (event) => {
    console.log(event); // log the event object
    $("#invoice_number_title").text('Invoice Number'); // corrected .text()

    if (event == 2) {
      $("#invoice_number_title").text('Credit Note Number');
    }
  };
  const changeSupplier = (event) => {
    console.log(event); // log the event object

    formik.setFieldValue('if', event.if);
    formik.setFieldValue('ice', event.ice);

    const event234 = event.value;
    console.log(event234); // log the event object

    if (event234 != "") {
      axios
        .get(`/financessuppliers/expenses-type-listing/${event234}`, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
          if (response.data.code === 200) {
            let customers = response.data.data.types;
            let addresses = customers.map((customer, index) => ({
              label: customer.title,
              value: customer.title,
              key: `address-${index}`,
            }));
            formik.setFieldValue('expense_type', response.data.data.type_selected);
            setTypeLists(addresses);

          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };
  const exptyples = ([
    { value: '1', label: "Invoice" },
    { value: '2', label: "Credit Note" },
  ]);

  const deleteItemFromDB = (item_id) => {
    const response_data = {};
    const userConfirmed = window.confirm("Are you sure you want to delete this item?");
    // If the user does not confirm, exit the function
    if (!userConfirmed) {
      return { status: 'cancelled' }; // Return a cancelled status if needed
    }
    response_data.status = 'false';
    axios.get(`/expenses/delete-item/${season_id + '-' + item_id}`, {
      headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
    }).then((response) => {
      if (response.data.code === 200) {
        response_data.status = 'ok';
        return response_data;
      }
    }).catch((error) => {
      console.log(error)
      response_data.status = 'false';

    });
    return response_data;
  };

  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Expense</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/expenses">Expenses</Link>
                    </li>
                    <li className="breadcrumb-item active">Edit</li>
                  </ul>
                </div>
              </div>
            </div>
            {permission?.update == 1 && (
              <FormikProvider value={formik}>
                <form onSubmit={formik.handleSubmit}>

                  <div className="row">
                    <div className="col-md-12">
                      <div className="card">
                        <div className="card-body">
                          <h4 className="card-title">EXPENSE INFORMATION</h4>
                          <div className="row">
                            <div className="col-md-6">
                              <div className="form-group status">
                                <label>Type</label>
                                {exptyples.length > 0 && (
                                  <Select
                                    className="w-100"
                                    value={exptyples.find(option => option.value == formik.values.type) || null} // Ensure correct format
                                    name="expense_type"
                                    //onChange={(selectedOption) => handleSelectChange("currency", selectedOption)}
                                    onChange={(selectedOption) => {
                                      handleSelectChange("type", selectedOption);
                                      changeType(selectedOption.value);
                                    }}
                                    onBlur={formik.handleBlur}
                                    options={exptyples}
                                    placeholder="Select"
                                  />
                                )}

                                <small>
                                  {backendErrors.type && (
                                    <span className="form-error mt-1">
                                      {backendErrors.type}
                                    </span>
                                  )}
                                </small>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label id="invoice_number_title">Invoice Number</label>
                                <input
                                  type="text"
                                  name="invoice_number"
                                  value={formik.values.invoice_number}
                                  className="form-input form-control datetimepicker"
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                  }}
                                  onBlur={formik.handleBlur}
                                />
                                <small>
                                  {backendErrors.invoice_number && (
                                    <span className="form-error mt-1">
                                      {backendErrors.invoice_number}
                                    </span>
                                  )}
                                </small>
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Invoice Date</label>
                                <input
                                  type="date"
                                  name="invoice_date"
                                  value={formik.values.invoice_date}
                                  className="form-input form-control"
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                  }}
                                  onBlur={formik.handleBlur}
                                />
                                <small>
                                  {backendErrors.invoice_date && (
                                    <span className="form-error mt-1">
                                      {backendErrors.invoice_date}
                                    </span>
                                  )}
                                </small>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group status">
                                <label>Supplier&apos;s Name</label>
                                {supplierName.length > 0 && (
                                  <Select
                                    className="w-100"
                                    value={supplierName.find(option => option.value == formik.values.supplier) || null} // Ensure correct format
                                    name="supplier"
                                    //onChange={(selectedOption) => handleSelectChange("currency", selectedOption)}
                                    onChange={(selectedOption) => {
                                      handleSelectChange("supplier", selectedOption);
                                      changeSupplier(selectedOption);
                                    }}
                                    onBlur={formik.handleBlur}
                                    options={supplierName}
                                    placeholder="Select"
                                  />
                                )}

                                <small>
                                  {backendErrors.supplier && (
                                    <span className="form-error mt-1">
                                      {backendErrors.supplier}
                                    </span>
                                  )}
                                </small>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label>IF</label>
                                <input
                                  type="text"
                                  name="if"
                                  value={formik.values.if}
                                  className="form-input form-control datetimepicker"
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);


                                  }}
                                  onBlur={formik.handleBlur}
                                />
                                <small>
                                  {backendErrors.if && (
                                    <span className="form-error mt-1">
                                      {backendErrors.if}
                                    </span>
                                  )}
                                </small>
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="form-group">
                                <label>ICE</label>
                                <input
                                  type="text"
                                  name="ice"
                                  value={formik.values.ice}
                                  className="form-input form-control datetimepicker"
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);


                                  }}
                                  onBlur={formik.handleBlur}
                                />
                                <small>
                                  {backendErrors.ice && (
                                    <span className="form-error mt-1">
                                      {backendErrors.ice}
                                    </span>
                                  )}
                                </small>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Invoice Due Date</label>
                                <input
                                  type="date"
                                  name="invoice_due_date"
                                  value={formik.values.invoice_due_date}
                                  className="form-input form-control"
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                  }}
                                  onBlur={formik.handleBlur}
                                />
                                <small>
                                  {backendErrors.invoice_due_date && (
                                    <span className="form-error mt-1">
                                      {backendErrors.invoice_due_date}
                                    </span>
                                  )}
                                </small>
                              </div>
                            </div>
                            {/* <div className="col-md-6">
                             <div className="form-group">
                                 <label>designation</label>
                                 <input
                                   type="text"
                                   name="designation"
                                   value={formik.values.designation}
                                   className="form-input form-control"
                                   onChange={(e) => {
                                     formik.handleChange(e);
                                     customHandleInput(e);
                                   }}
                                   onBlur={formik.handleBlur}
                                 />
                                 <small>
                                   {backendErrors.designation && (
                                       <span className="form-error mt-1">
                                         {backendErrors.designation}
                                       </span>
                                     )}
                                 </small>
                               </div>
                             </div> */}


                            <div className="col-md-6">
                              <div className="form-group status">
                                <label>Expense Type</label>
                                {typeLists.length > 0 && (
                                  <Select
                                    className="w-100"
                                    value={typeLists.find(option => option.value == formik.values.expense_type) || null} // Ensure correct format
                                    name="expense_type"
                                    //onChange={(selectedOption) => handleSelectChange("currency", selectedOption)}
                                    onChange={(selectedOption) => {
                                      handleSelectChange("expense_type", selectedOption);
                                      changeExpenseType(selectedOption.value);
                                    }}
                                    onBlur={formik.handleBlur}
                                    options={typeLists}
                                    placeholder="Select"
                                  />
                                )}
                                <small>
                                  {backendErrors.expense_type && (
                                    <span className="form-error mt-1">
                                      {backendErrors.expense_type}
                                    </span>
                                  )}
                                </small>
                              </div>
                            </div>

                            <div className="col-md-6 " id="nature-block" style={{ display: 'none' }}>
                              <div className="form-group">
                                <label>Nature</label>

                                {tvarates.length > 0 && (
                                  <Select
                                    className="w-100"
                                    value={naturelist.find(option => option.value == formik.values.nature) || null} // Ensure correct format
                                    name="nature"
                                    //onChange={(selectedOption) => handleSelectChange("currency", selectedOption)}
                                    onChange={(selectedOption) => {
                                      handleSelectChange("nature", selectedOption);

                                    }}
                                    onBlur={formik.handleBlur}
                                    options={naturelist}
                                    placeholder="Select"
                                  />
                                )}
                                <small>
                                  {backendErrors.nature && (
                                    <span className="form-error mt-1">
                                      {backendErrors.nature}
                                    </span>
                                  )}
                                </small>
                              </div>
                            </div>
                            <div className="col-md-6 " id="expense_type_extention-block" style={{ display: 'none' }}>
                              <div className="form-group">
                                <label>Expense Type Extention</label>

                                <input
                                  type="text"
                                  name="expense_type_extention"
                                  value={formik.values.expense_type_extention}
                                  className="form-input form-control"
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                  }}
                                  onBlur={formik.handleBlur}
                                />
                                <small>
                                  {backendErrors.expense_type_extention && (
                                    <span className="form-error mt-1">
                                      {backendErrors.expense_type_extention}
                                    </span>
                                  )}
                                </small>
                              </div>
                            </div>


                            <div className="col-md-6">
                              <div className="form-group status2">
                                <label>Select Currency</label>

                                <Select
                                  className="w-100"
                                  value={primaryCurrency.find(option => option.value == formik.values.currency) || null} // Ensure correct format
                                  name="currency"
                                  //onChange={(selectedOption) => handleSelectChange("currency", selectedOption)}
                                  onChange={(selectedOption) => {
                                    handleSelectChange("currency", selectedOption);
                                    customFuction(selectedOption);
                                  }}
                                  onBlur={formik.handleBlur}
                                  options={primaryCurrency}
                                  placeholder="Select"
                                />
                                <small>
                                  {backendErrors.currency && (
                                    <span className="form-error mt-1">
                                      {backendErrors.currency}
                                    </span>
                                  )}
                                </small>
                              </div>

                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <label>amount HT</label>

                                <div className="input-group">
                                  <input
                                    type="text"
                                    onKeyPress={(event) => {
                                      // Allow only numbers (0-9)
                                      if (!/^[0-9.]$/.test(event.key) || (event.key === '.' && event.target.value.includes('.'))) {
                                        event.preventDefault();
                                      }
                                    }}
                                    name="amount_ht"
                                    value={formik.values.amount_ht}
                                    onChange={(e) => {
                                      formik.handleChange(e);
                                      customHandleInput(e);
                                    }}
                                    onBlur={formik.handleBlur}
                                    className="form-control" placeholder="amount HT" aria-label="amount HT" aria-describedby="basic-addon2" />
                                  <div className="input-group-append">
                                    <span className="input-group-text" id="basic-addon2">{currencySymbol}</span>
                                  </div>
                                </div>
                                <small>
                                  {backendErrors.amount_ht && (
                                    <span className="form-error mt-1">
                                      {backendErrors.amount_ht}
                                    </span>
                                  )}
                                </small>
                              </div>
                            </div>

                          </div>


                          <FieldArray
                            name="contents"
                            render={(arrayHelpers) => (
                              <div>
                                <button
                                  className="btn btn-primary mb-3"
                                  type="button"
                                  onClick={() => {
                                    let initialArr = {
                                      tva_rate: "",
                                      tva_amount: "",
                                    }
                                    arrayHelpers.push(initialArr);
                                  }}
                                >
                                  +
                                </button>


                                {formik.values.contents.map(
                                  (friend, index) => (
                                    <div className="row" key={index}>

                                      <div className="col-md-5">
                                        <div className="form-group status">
                                          <label> TVA Rate</label><br />

                                          <Select
                                            name={`contents[${index}].tva_rate`}
                                            options={tvarates}
                                            value={tvarates.find(option => option.value == formik.values.contents[index].tva_rate) || null} // Ensure correct format
                                            onChange={(selectedOption) => {
                                              formik.setFieldValue(`contents[${index}].tva_rate`, selectedOption.value); // ✅ Store only value in Formik
                                              customHandleInput({
                                                target: {
                                                  name: `contents[${index}].tva_rate`,
                                                  value: selectedOption.value, // ✅ Ensure only value is passed
                                                },
                                              });
                                            }}
                                            onBlur={formik.handleBlur}
                                            placeholder="Select"
                                            className="w-100"

                                          />
                                        </div>
                                      </div>
                                      <div className="col-md-5">
                                        <div className="form-group">
                                          <label>TVA Amount</label><br />
                                          <input
                                            type="text"
                                            onKeyPress={(event) => {
                                              // Allow only numbers (0-9)
                                              if (!/^[0-9.]$/.test(event.key)) {
                                                event.preventDefault();
                                              }
                                            }}
                                            placeholder="Enter TVA Amount"
                                            className="form-input form-control"
                                            name={`contents[${index}].tva_amount`}
                                            value={
                                              formik.values.contents[index]
                                                .tva_amount
                                            }
                                            //onChange={formik.handleChange}
                                            onChange={(e) => {
                                              formik.handleChange(e);
                                            }}
                                          />
                                        </div>
                                      </div>



                                      <div className="col-md-2">
                                        <div className="form-group"
                                          style={{ marginTop: 30 }}>
                                          <button
                                            className="btn btn-danger"

                                            type="button"

                                            onClick={() => {
                                              let item_record = formik.values.contents[index];

                                              console.log(item_record);
                                              if (item_record.id == undefined) {
                                                arrayHelpers.remove(index)
                                              } else {
                                                deleteItemFromDB(item_record.id);
                                                arrayHelpers.remove(index)
                                              }
                                            }}
                                          >
                                            -
                                          </button>
                                          {index === formik.values.contents.length - 1 && (
                                            <button
                                              className="btn btn-primary"
                                              type="button"

                                              onClick={() => {
                                                //let appendArr = arrayHelpers.form.values.contents[0];
                                                let initialArr = {
                                                  tva_rate: "",
                                                  tva_amount: "",
                                                }
                                                //appendArr = (appendArr) ? appendArr : initialArr;
                                                arrayHelpers.push(initialArr);
                                              }}
                                            >
                                              +
                                            </button>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  )
                                )}

                              </div>
                            )}
                          />


                          <div className="row">


                            <div className="col-md-6">
                              <div className="form-group">
                                <label>Total Amount TTC</label>
                                <input
                                  type="text"
                                  onKeyPress={(event) => {
                                    // Allow only numbers (0-9)
                                    if (!/^[0-9.]$/.test(event.key) || (event.key === '.' && event.target.value.includes('.'))) {
                                      event.preventDefault();
                                    }
                                  }}
                                  name="total_amount_ttc"
                                  value={formik.values.total_amount_ttc}
                                  className="form-input form-control"
                                  onChange={(e) => {
                                    formik.handleChange(e);
                                    customHandleInput(e);
                                  }}
                                  onBlur={formik.handleBlur}
                                />
                                <small>
                                  {backendErrors.total_amount_ttc && (
                                    <span className="form-error mt-1">
                                      {backendErrors.total_amount_ttc}
                                    </span>
                                  )}
                                </small>
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="form-group status">
                                <label>Invoice Attachment</label>

                                <input
                                  className="form-control"
                                  type="file"
                                  name="invoice_attachment"
                                  onChange={(event) => {
                                    const file_link = event.target.files[0];
                                    //console.log("file:", file_link);
                                    //const fileName = file_link.name;
                                    //const fileName = file_link.name;
                                    const reader = new FileReader();

                                    reader.onloadend = () => {
                                      formik.setFieldValue(
                                        "invoice_attachment",
                                        reader.result
                                      );
                                    };

                                    if (file_link) {
                                      reader.readAsDataURL(file_link);
                                    }
                                  }}
                                />

                                <small>
                                  {backendErrors.invoice_attachment && (
                                    <span className="form-error mt-1">
                                      {backendErrors.invoice_attachment}
                                    </span>
                                  )}
                                </small>
                              </div>
                            </div>



                          </div>

                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-12">
                      <div className="card">
                        <div className="card-body">
                          <div className="text-end mt-4">
                            <button className="btn btn-primary" type="submit" id="form-submit" disabled={formik.isSubmitting}>
                              Update Expense
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>


                </form>
              </FormikProvider>
            )}

          </div>
        </div>
      </div>
    </>
  );
};
export default ExpenseEdit;
